import { Controller } from "@hotwired/stimulus";

// Renders a Cloudflare Turnstile widget with explicit rendering so it
// survives Turbo re-renders (api.js only scans for implicit widgets once, on
// script load). The widget injects a hidden `cf-turnstile-response` input
// into the surrounding form.
export default class extends Controller {
  static values = { sitekey: String };

  connect() {
    this.active = true;

    loadTurnstile()
      .then(() => {
        // Turbo may have swapped the page out while the script was loading;
        // rendering into a detached element would leak an orphaned widget.
        if (!this.active) return;

        this.widgetId = window.turnstile.render(this.element, {
          sitekey: this.sitekeyValue,
        });
      })
      .catch(() => {
        // The script failed to load (blocked, offline). The form submits
        // without a token and the server-side check rejects it.
      });
  }

  disconnect() {
    this.active = false;

    if (this.widgetId) {
      window.turnstile.remove(this.widgetId);
      this.widgetId = null;
    }
  }
}

let turnstileScriptPromise;

function loadTurnstile() {
  if (window.turnstile) return Promise.resolve();

  turnstileScriptPromise ||= new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src =
      "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.onload = resolve;
    script.onerror = () => {
      // Don't cache the failure: let the next connect() retry the load.
      script.remove();
      turnstileScriptPromise = undefined;
      reject(new Error("Failed to load Turnstile"));
    };
    document.head.appendChild(script);
  });

  return turnstileScriptPromise;
}
